import { useAppSelector } from '../../global/hooks';
import { PlainNumberInput } from '../../global/styles';
import { selectBpm, setBpm } from '../../store/appSlice';
import NoteIcon from '../Icons/NoteIcon';
import { OtherButton } from './styles';
import { useDispatch } from 'react-redux';
import * as Tone from 'tone';

export default function BpmEdit() {
	const dispatch = useDispatch();
	const bpm = useAppSelector(selectBpm);
	const handleSetBpm = (newBpm: number) => {
		dispatch(setBpm(newBpm));
		// @TODO SAVE
		if (window != null) {
			Tone.Transport.bpm.value = newBpm;
		} else {
			console.warn('window is not defined');
		}
	};

	return (
		<OtherButton title="change bpm" aria-label="change bpm">
			<label htmlFor="bpm">
				<NoteIcon width={10} height={13} />
				<PlainNumberInput
					id="bpm"
					min={40}
					max={400}
					step={1}
					value={bpm}
					onChange={e => handleSetBpm(e.target.valueAsNumber)}
				/>
				bpm
			</label>
		</OtherButton>
	);
}
